module.exports = __webpack_public_path__ + "img/ver4.759196c8.jpg";